export interface ElementForPlannedHours {
  id: string
  type?: string
  parentId?: string | null
  checklist?: Array<{ estimatedHours?: number | null }> | null
}

export interface ChecklistItemForPlannedHours {
  parentContainerId?: string | null
  parentId?: string | null
  estimatedHours?: number | null
}

export function calculatePlannedHoursByGoal(
  elements: readonly ElementForPlannedHours[],
  checklistItems: readonly ChecklistItemForPlannedHours[] = [],
): Map<string, number> {
  const goals = elements.filter((el) => el.type === 'GOAL')
  const plannedByGoal = new Map<string, number>()
  if (goals.length === 0) return plannedByGoal

  const elementById = new Map<string, ElementForPlannedHours>()
  for (const el of elements) {
    elementById.set(el.id, el)
  }

  const goalMap = new Map<string, string>()
  const getGoalId = (id: string | null | undefined): string | null => {
    if (!id) return null
    if (goalMap.has(id)) return goalMap.get(id)!
    const visited = new Set<string>()
    let curr: string | null = id
    while (curr && !visited.has(curr)) {
      visited.add(curr)
      const el = elementById.get(curr)
      if (!el) break
      if (el.type === 'GOAL') {
        goalMap.set(id, el.id)
        return el.id
      }
      curr = el.parentId ?? null
    }
    goalMap.set(id, '')
    return null
  }

  for (const item of checklistItems) {
    const containerId = item.parentContainerId || item.parentId
    const gId = getGoalId(containerId)
    if (gId) {
      const est = Number(item.estimatedHours) || 0
      if (est > 0) {
        plannedByGoal.set(gId, (plannedByGoal.get(gId) || 0) + est)
      }
    }
  }

  for (const el of elements) {
    const gId = getGoalId(el.id)
    if (gId && Array.isArray(el.checklist)) {
      for (const item of el.checklist) {
        const est = Number(item.estimatedHours) || 0
        if (est > 0) {
          plannedByGoal.set(gId, (plannedByGoal.get(gId) || 0) + est)
        }
      }
    }
  }

  return plannedByGoal
}
